import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiHandler } from "../../api";
import { API_BASE_URL, endpoint } from "../../api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";

export const useMiscSettlementDetails = () => {
  const dispatch = useDispatch();
    const navigate = useNavigate();
  
  const { addToast } = useToasts();
  const { authData,storeId } = useSelector((state) => state.loginSlice);
  const { settlementId } = useParams();
  const isMounted = useRef(true);
  const [settlementData, setSettlementData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

   const handleGoBack = () => {   
    navigate(-1);
  };

  useEffect(() => {
    const fetchSettlementDetails = async () => {
      setLoading(true);
      setError(null);

      try {
        const result = await apiHandler({
          url: `${endpoint.GET_MISC_SETTLEMENT_DETAILS}${settlementId}`,
          method: "GET",
          authToken: authData,
          dispatch,
          storeId
        });


        if (isMounted.current && result?.data?.settleDetails) {
          setSettlementData(result.data.settleDetails); // Directly storing the fetched data
        }
      } catch (err) {
    
        if (isMounted.current) setError("Failed to fetch settlement details.");
      } finally {
        setLoading(false);
      }
    };

    if (settlementId) fetchSettlementDetails();

    return () => {
      isMounted.current = false;
    };
  }, [settlementId]);

 

  return {
    settlementId,
    settlementData,
    error,
    loading,
    handleGoBack
  };
};
